import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "attendance-root" }
const _hoisted_2 = { class: "attendance-toolbar" }
const _hoisted_3 = { class: "attendance-date" }
const _hoisted_4 = {
  key: 0,
  class: "attendance-add"
}
const _hoisted_5 = {
  key: 0,
  class: "attendance-add-panel"
}
const _hoisted_6 = ["value"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "attendance-empty"
}
const _hoisted_9 = {
  key: 1,
  class: "attendance-empty"
}
const _hoisted_10 = {
  key: 2,
  class: "attendance-grid"
}
const _hoisted_11 = { class: "attendance-card-head" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "attendance-person" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 1,
  class: "attendance-role"
}
const _hoisted_17 = {
  key: 2,
  class: "attendance-tag"
}
const _hoisted_18 = { class: "attendance-status" }
const _hoisted_19 = {
  key: 0,
  class: "attendance-actions"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("label", { for: "attendance-date" }, "Data", -1)),
        _withDirectives(_createElementVNode("input", {
          id: "attendance-date",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedDate) = $event)),
          type: "date"
        }, null, 512), [
          [_vModelText, _ctx.selectedDate]
        ])
      ]),
      (_ctx.accessMode === 'edit')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("button", {
              class: "attendance-add-btn",
              type: "button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showAddPicker = !_ctx.showAddPicker))
            }, "+ Adicionar presença"),
            (_ctx.showAddPicker)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedExtraKey) = $event))
                  }, [
                    _cache[5] || (_cache[5] = _createElementVNode("option", { value: "" }, "Selecione um funcionário", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableEmployees, (employee) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: employee.key,
                        value: employee.key
                      }, _toDisplayString(employee.name) + _toDisplayString(employee.username ? ` (@${employee.username})` : ''), 9, _hoisted_6))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.selectedExtraKey]
                  ]),
                  _createElementVNode("button", {
                    class: "attendance-action attendance-action--present",
                    type: "button",
                    disabled: !_ctx.selectedExtraKey,
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addExtraAttendance && _ctx.addExtraAttendance(...args)))
                  }, "Adicionar", 8, _hoisted_7)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Carregando presenças..."))
      : (_ctx.members.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Nenhum funcionário disponível nesta data."))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.members, (member) => {
              return (_openBlock(), _createElementBlock("article", {
                key: member.key,
                class: _normalizeClass(["attendance-card", member.status === 'present' ? 'is-present' : 'is-absent'])
              }, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", {
                    class: "attendance-avatar",
                    style: _normalizeStyle({ background: _ctx.avatarColor(member.name) })
                  }, [
                    (member.photoUrl)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _ctx.$resolveUrl(member.photoUrl),
                          alt: "foto"
                        }, null, 8, _hoisted_12))
                      : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.initials(member.name)), 1))
                  ], 4),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("strong", null, _toDisplayString(member.name), 1),
                    (member.username)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, "@" + _toDisplayString(member.username), 1))
                      : _createCommentVNode("", true),
                    (member.roleName)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(member.roleName), 1))
                      : _createCommentVNode("", true),
                    (!member.inProject)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, "Extra do dia"))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["attendance-pill", member.status === 'present' ? 'attendance-pill--present' : 'attendance-pill--absent'])
                  }, _toDisplayString(member.status === 'present' ? `Presente${member.time ? ` • ${member.time}` : ''}` : 'Ausente'), 3)
                ]),
                (_ctx.accessMode === 'edit')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("button", {
                        class: "attendance-action attendance-action--present",
                        type: "button",
                        onClick: ($event: any) => (_ctx.markPresent(member))
                      }, "Presente", 8, _hoisted_20),
                      _createElementVNode("button", {
                        class: "attendance-action attendance-action--absent",
                        type: "button",
                        onClick: ($event: any) => (_ctx.markAbsent(member))
                      }, "Ausente", 8, _hoisted_21)
                    ]))
                  : _createCommentVNode("", true)
              ], 2))
            }), 128))
          ]))
  ]))
}